import { Component } from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import BranchPicker from "@/pages/BranchPicker";
import Menu from "@/pages/Menu";
import MenuNotFound from "@/components/MenuNotFound";

const router = createBrowserRouter([
  { path: "/", element: <BranchPicker /> },
  { path: "/:branchSlug", element: <Menu /> },
]);

// Render hatasında beyaz ekran yerine hata sayfası; sourcemap'lerle console'dan teşhis.
class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("[menu] render crash", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <MenuNotFound
          title="Bir Hata Oluştu"
          message="Lütfen sayfayı yenileyin."
        />
      );
    }
    return this.props.children;
  }
}

export default function App() {
  return (
    <ErrorBoundary>
      <RouterProvider router={router} />
    </ErrorBoundary>
  );
}
